/**
 * SIDC MMS Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InvestmentDTO { 
    memberCode?: string;
    investmentProjectTypeId?: string;
    amount?: string;
    interest?: string;
    returnOnInvestment?: string;
    total?: string;
    certificateControlNumber?: string;
    option?: string;
    returnOnInvestmentPercentage?: string;
    amountOfInvestmentPercentage?: string;
    investmentDate?: string;
}